import React from 'react';
import {
    DescriptionAndImage,
    Title,
    ItemsContainer,
    Item,
    ImageContainer,
    Image
} from "../../CommonStyles";
import Row from '../../../Shared/Kit/Row';
import Col from '../../../Shared/Kit/Col';
import image from "../../../Assets/Images/Image.png";

const itemConfig = [
    {
        title: "تعداد بلوک ها",
        description: "24 بلوک"
    },
    {
        title: "مساحت کل زمین",
        description: "حدود 107750 مترمربع در 6 قطعه"
    },
    {
        title: "مساحت کل زیربنا",
        description: "794427 مترمربع"
    },
    {
        title: "مساحت مفید مسکونی",
        description: "483684 مترمربع"
    },
    {
        title: "مساحت مفید تجاری",
        description: "10828 مترمربع"
    },
    {
        title: "تعداد واحد مسکونی",
        description: "3876 واحد"
    },
    {
        title: "تعدلد واحد تجاری",
        description: "277 واحد"
    },
]

const Section1 = () => {
    return (
        <>
            <DescriptionAndImage>
                <Row>
                    <Title>
                        مشخصات
                    </Title>
                    <ItemsContainer className="p-r">
                        {itemConfig.map((each, index) => {
                            return (
                                <Item key={index} xl={10}>
                                    <Row className="title">
                                        <Col className="bullet" />
                                        {each.title}
                                    </Row>
                                    <Row className="description">
                                        {each.description}
                                    </Row>
                                </Item>
                            )
                        })}
                    </ItemsContainer>
                </Row>
                <ImageContainer>
                    <Image source={image} />
                </ImageContainer>
            </DescriptionAndImage>
        </>

    )
}

export default Section1;